import React , {useState, useContext, useCallback}  from 'react';
import _ from 'lodash';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLScriptComponent } from 'ml-components-common-react';
import { MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import PropTypes from 'prop-types';
import metadata from './AvailableDocumentsComponent.metadata.json5';
import messages from './AvailableDocumentsComponent.messages';
import styles from './AvailableDocumentsComponent.module.scss';

//US993539
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import MLDocumentsUpload from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/GatewayMLDocumentsUploadPopup';
import MLDocumentsUploadPopupMsg from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/MLDocumentsUploadPopup.messages';
import mlDocumentsUploadPopupMetadata from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/MLDocumentsUploadPopup.metadata.json5';
import { useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { EndorsementService } from 'gw-capability-policychange';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';

const AvailableDocumentsComponent = (props) => {
    const { 
        availableDocumentsForms,
        isUserRetentionAgent,
        convertDateToUTC,
        viewDocument,
        uwIssues,
        jobID,
        blockingUWIssuesPresentCallback,
        approvedAllBlockingUWIssuesCallback,
        endorsementVM,
        setIsFileUploadDone,
        contingencies,
        refreshPreBindContingencyData,
    } = props;
    //US993539
    const modalApi = useModal();
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(true);
    if(contingencies?.length>0){
        if(setIsFileUploadDone !== undefined)
            setIsFileUploadDone(true);
    }
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
   
    const {
        showProgressDialog,
        showErrorModal
    } = MLModalService();

    const translator = useTranslator();

    const generateAdFormsOverrides = () => {
        const getTypeKeyDescription = (typeKeyName) => {
            return translator({
                id: typeKeyName,
                defaultMessage: typeKeyName
            });
        };

        const overrides = availableDocumentsForms.map((adForm, index) => {
            return {
                [`formDescription${index}`]: {
                    content: adForm.formDescription.value
                },
                [`isSignedIcon${index}`]: {
                    visible: adForm.isSigned.value === true
                },
                [`signatureType${index}`]: {
                    className: adForm.isSigned.value === true ? 'ml-bold' : undefined,
                    content: adForm.signatureType.value ? getTypeKeyDescription(adForm.signatureType.value.name) : ''
                },
                [`userRetentionAgentDateSignedContainer${index}`]: {
                    visible: isUserRetentionAgent && adForm.signatureType.value && adForm.signatureType.value.code !== 'esignature'
                },
                [`notUserRetentionAgentDateSignedContainer${index}`]: {
                    visible: !(isUserRetentionAgent && adForm.signatureType.value && adForm.signatureType.value.code === 'esignature')
                },
                [`notUserRetentionAgentDateSigned${index}`]: {
                    visible: adForm.isSigned.value === true,
                    content: `${convertDateToUTC(adForm.signedDateTime.value)} ${translator(messages.ut)}`
                },
                [`notUserRetentionAgentNotSigned${index}`]: {
                    visible: adForm.isSigned.value !== true
                },
                [`formLanguageSelectedContainer${index}`]: {
                    visible: !_.isNil(adForm.formLanguage.value)
                },
                [`viewEnglishDocument${index}`]: {
                    onClick: () => viewDocument(adForm)
                },
                [`viewSpanishDocument${index}`]: {
                    onClick: () => viewDocument(adForm)
                },
                [`viewDocument${index}`]: {
                    visible: _.isNil(adForm.formLanguage.value),
                    onClick: () => viewDocument(adForm)
                }
            }
        })
        return Object.assign({}, ...overrides);
    };

    const overrideProps  = {
        uwIssuePanel: {
            visible: !_.isEmpty(uwIssues),
            uwIssues,
            jobID,
            hideIfAllApproved: true,
            blockingUWIssuesPresentCallback,
            approvedAllBlockingUWIssuesCallback
        },
        notUserRetentionPageDesc: {
            visible: !isUserRetentionAgent,
            content: (
                <FormattedMessage
                    {...messages.allDocsSigned}
                    values={{
                        requiredDocuments: <strong>{translator(messages.requiredDocuments)}</strong>
                    }}
                />
            )
        },
        userRetentionPageDesc: {
            visible: isUserRetentionAgent,
            content: (
                <FormattedMessage
                    {...messages.docsRetained}
                    values={{
                        followingDocuments: <strong>{translator(messages.followingDocuments)}</strong>
                    }}
                />
            )
        },
        availableDocumentsFormsIterable: {
            data: availableDocumentsForms
        },
        refreshLoadingButton: {
            visible: true,
        },
        refreshDiv:{
            onClick:()=>{refreshPreBindContingencyData()}
        },
        uwWrapperNonRefer:{
            visible: isUWIssuesPanelVisible
        },
        uwIssuesPanelLink:{
            visible: true,
            onclick:()=>{toggleUWIssuesPanel()},
            content: isUWIssuesPanelVisible ? translator(messages.hideAllIssues) : translator(messages.showAllIssues)
        },
        MLUWIssuesPanelComponent:{
            visible:contingencies?.length > 0
        },
        nonReferUwIssueIterableComponennt: {
            content: [(
            <div>
                {
                    contingencies?.map((value) => {
                    return (
                        <div id="parentUwIssueItemNonRefer" className="uw-issue">
                            <div id="spanContainer">
                                <span id="reasonP" className="body-copy font-weight-bold">
                                    {"Contingency :"}
                                </span>
                                <p id="showBundleIssues" className="body-copy display-inline-block"></p>
                                <p id="descrP" className="body-copy display-inline-block">
                                    {value.description_ML}
                                </p>
                                <span
                                    id="btnDividerSpanNonRefer"
                                    className="uw-issue-button-divider"
                                >{" "}</span>
                                <a
                                    id="uploadProofBtn"
                                    type="button"
                                    onClick={(e) => onUploadDocumentClicked(value)}
                                    className="vertical-spacing-0"
                                >
                                    {"Upload Proof"}
                                </a>
                            </div>
                        </div>
                    );
                })
                }
            </div>
            )]
        },
        ...generateAdFormsOverrides()
    };
    const toggleUWIssuesPanel = () => {
        setIsUWIssuesPanelVisible(!isUWIssuesPanelVisible);
    }; 

    const resolvers = {
        resolveCallbackMap: {
            onToggleUWIssuesPanel: toggleUWIssuesPanel,
            onRefreshPreBind: refreshPreBindContingencyData,
        },
        resolveComponentMap: {
            mlScriptComponent: MLScriptComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        },
        resolveClassNameMap: styles
    }
    
    //US993539
    const onUploadDocumentClicked = useCallback((contingency) => {
        openAddNoteDialog(contingency);
    }, []);

    const openAddNoteDialog = (contingency) => {
        let policyInfo = endorsementVM.value
        const componentProps = {
            showHeader: false,
            uiProps: mlDocumentsUploadPopupMetadata.componentContent,
            actionBtnLabel: _.upperCase(translator(MLDocumentsUploadPopupMsg.continue)),
            cancelBtnLabel: MLDocumentsUploadPopupMsg.cancelModal,
            disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
            viewModelService,
            authHeader,
            CustomComponent: MLDocumentsUpload,
            overrideProps: {
                policyNumber: endorsementVM.policyNumber.value,
                isAgent: true,
                policy: policyInfo,
                contingencyName: contingency?.title,
                isFromPolicyChangeScreen:true,
                setIsFileUploadDone,
                contingency
            },
            onSaveAction: () => {
                return false;
            },
            buttonType: 'secondary'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

AvailableDocumentsComponent.propTypes = {
    availableDocumentsForms: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isUserRetentionAgent: PropTypes.bool.isRequired,
    convertDateToUTC: PropTypes.func.isRequired,
    scriptML: PropTypes.shape({}).isRequired,
    viewDocument: PropTypes.func.isRequired,
    uwIssues: PropTypes.arrayOf(PropTypes.shape({})),
    quoteID: PropTypes.string,
    blockingUWIssuesPresentCallback: PropTypes.func.isRequired,
    approvedAllBlockingUWIssuesCallback: PropTypes.func.isRequired
};

AvailableDocumentsComponent.defaultProps = {
    uwIssues: []
};

export default AvailableDocumentsComponent;
